import Big from "big.js";
import store from "../store";
import { labelForCode, codeFromHasTax } from "./taxCatalog";

const ProformaItem = class {
    constructor(object) {
        if (object === undefined) {
            this.uid = null;
            this.id = null;
            this.code = null;
            this.productId = null;
            this.product = null;
            this.productObj = null;
            this.hasTax = false;
            this.ivaCode = '0';
            this.iceCode = null;
            this.iceValue = new Big('0.0');
            this.amount = new Big('0.0');
            this.discount = new Big('0.0');
            this.readableDiscount = new Big('0.0');
            this.unitPrice = new Big('0.0');
            this.priceList = [0.0];
        } else {
            this.uid = object.uid || this.makeid(10);
            this.id = object.id || null;
            this.code = object.code || object.productId;
            this.productId = object.productId || null;
            this.product = object.product;
            this.productObj = object.productObj;
            this.hasTax = object.hasTax;
            this.ivaCode = object.ivaCode || codeFromHasTax(object.hasTax, store.getters.business.taxPercentage);
            // ICE congelado del item (lo calcula el backend desde el producto).
            this.iceCode = object.iceCode || null;
            this.iceValue = (object.iceValue !== undefined && object.iceValue !== null) ? new Big(object.iceValue) : new Big('0.0');
            this.amount = (object.amount !== undefined) ? new Big(object.amount) : new Big('1.0');
            this.discount = (object.discount !== undefined) ? new Big(object.discount) : new Big('0.0');
            this.readableDiscount = this.discount.times(100).round(2);
            this.unitPrice = (object.unitPrice !== undefined) ? new Big(object.unitPrice) : new Big('0.0');
            this.priceList = object.priceList;
        }
        this.readableTax = labelForCode(this.ivaCode);
    }

    get totalPrice() {
        // totalPrice = unitPrice * amount * (1 - discount)
        return this.unitPrice.times(this.amount).times(this.discount.times(-1).plus(1)).round(2);
    }

    applyDiscount(discount) {
        this.discount = new Big(discount);
        // No es necesario recalcular totalPrice aquí porque es un getter
        this.readableDiscount = this.discount.times(100).round(2);
    }

    makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
}

export default ProformaItem